import * as React from 'react'
import { Link } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { styles } from './styles.css'
import mypage from './images/mypage.svg'
import login from './images/login.svg'

type Props = {
  isLoggedIn: boolean
  className?: string
}

export const LoginLink: React.FC<Props> = ({ isLoggedIn, className }) => {
  const href = isLoggedIn ? '/subscription/mypage' : '/subscription/login'

  return (
    <Link to={href} className={`${styles.link} ${className}`}>
      <Flex direction="row" align="center" gap="2px">
        <img src={isLoggedIn ? mypage : login} className={styles.image} />
        {isLoggedIn ? 'マイページ' : 'ログイン'}
      </Flex>
    </Link>
  )
}
